import script from "./CompaniesListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesListView.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesListView.vue?vue&type=style&index=0&id=0a2dc464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2dc464"]])

export default __exports__